import Image from 'next/image';
import Link from 'next/link';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';

interface GridItemProps {
  item: {
    recipeMetaSection?: { title?: string };
    _meta?: { deliveryKey?: string };
    assets?: Array<Record<string, any>>;
  };
}

const GridItem = ({ item }: GridItemProps) => {
  const { recipeMetaSection, _meta, assets } = item || {};
  const { deliveryKey } = _meta || {};
  const imgUrl = assets?.length
    ? buildImageSrc(assets[0], 400, 4, 3)
    : buildImageSrc(null, 400, 4, 3);
  const linkObj = buildLinkObj({ link: deliveryKey });

  return (
    <div className="bg-white h-full p-2 sm:p-8">
      <Link href={linkObj.href} className="flex flex-col h-full">
        <div className="relative w-full aspect-[4/3]">
          <Image src={imgUrl} alt="" fill className="object-cover" priority={false} />
        </div>
        <h6 className="tra-text-web-heading-6 mt-3 text-left">{recipeMetaSection?.title}</h6>
      </Link>
    </div>
  );
};

export default GridItem;
